import {faForwardStep} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button} from 'antd';

import {Text} from '../../../../../component/text/text';
import {VideoPlayer} from '../../../../../component/video-popup/video-player';
import {Locale} from '../../../../../provider/locale/locale';
import {FutureMarketingEvent} from '../incomming-marketing-event/future-marketing-event';
import {KnowledgeHelpVideoType} from '../knowledge-help-videos-type';

import * as styles from './knowledge-video-active.scss';

type PropsType = {
    videoRecommendation: KnowledgeHelpVideoType;
    onNext: VoidFunction | null;
};

export function KnowledgeVideoActive(props: PropsType): JSX.Element {
    const {videoRecommendation, onNext} = props;

    return (
        <section className={styles.KnowledgeVideoActive}>
            <FutureMarketingEvent />

            <div className={styles.KnowledgeVideoActive_previewWrapper}>
                <VideoPlayer url={videoRecommendation.videoLink || ''} />
            </div>

            <Text block bolder className={styles.KnowledgeVideoActive_title} large>
                {videoRecommendation.config.title}
            </Text>

            <Text block secondary>
                {videoRecommendation.config.description}
            </Text>

            <div className={styles.KnowledgeVideoActive_actions}>
                <Button
                    disabled={!onNext}
                    icon={<FontAwesomeIcon icon={faForwardStep} />}
                    onClick={() => onNext?.()}
                    type="default"
                >
                    <Locale stringKey="HELP_TECHNICAL__VIDEOS__NEXT_VIDEO" />
                </Button>
            </div>
        </section>
    );
}
